import React from 'react'
import { AppContext } from '../../App'
import * as Request from '../../utilities/request'

import { Col, Row } from 'react-bootstrap'
import { Loading } from '../ui/Loading/Loading'
import { properCase, roundToTwo } from '../../utilities/format'
import { RecentUtilisation, Utilisation, UtilisationPeriod } from '../../../../back-end/common/billyDashboard'
import DashboardCard from './dashboardCard'
import { TestingStaff } from '../../screens/dashboard/dashboardWrapper'

const missingHours = (util: Utilisation) => roundToTwo(util.standardWorkingHoursPeriodTotal - util.billableHours - util.nonBillableHours)

interface MissingTimesheetsProps {
	period: UtilisationPeriod
	testingStaff?: TestingStaff
}

const MissingTimesheets = (props: MissingTimesheetsProps) => {
	const { appState } = React.useContext(AppContext)

	const [recentUtilisation, setRecentUtilisation] = React.useState<RecentUtilisation | null>(null)
	const [errorMsg, setErrorMsg] = React.useState<string | null>(null)

	React.useEffect(() => {
		const getData = async () => {
			const testingStaffXpmID = props.testingStaff ? '/' + props.testingStaff.xpmID : ''
			const utilRes = await Request.get(`billydashboard/util${testingStaffXpmID}?period=${props.period}`)

			setRecentUtilisation(utilRes.data.recentUtilisation)

			if (!utilRes.data.success) {
				setErrorMsg(utilRes.data.message)
			}
		}

		if (appState.authState.isLoggedIn) {
			getData()
		}
	}, [appState.authState, props])

	if (errorMsg) {
		return (
			<DashboardCard background={props.period}>
				<div className="center-flex p-3">
					<span className="span-body-2 span-white">{errorMsg}</span>
				</div>
			</DashboardCard>
		)
	}

	if (!recentUtilisation) {
		return (
			<DashboardCard background={props.period}>
				<div className="center-flex">
					<Loading show style={{ color: 'white' }} />
				</div>
			</DashboardCard>
		)
	}

	return (
		<DashboardCard background={props.period}>
			<Row className="pb-2">
				<Col>
					<span className="span-body-2 span-bold span-white">MISSING TIMESHEETS</span>
				</Col>
			</Row>
			<Row>
				<Col className="d-flex flex-column">
					<span className="span-body-2 span-bold span-white">This {properCase(recentUtilisation.period)}</span>
					<span className="span-body-2 span-white">{missingHours(recentUtilisation.currentPeriod)} hrs</span>
				</Col>
				<Col className="d-flex flex-column">
					<span className="span-body-2 span-bold span-white">Last {properCase(recentUtilisation.period)}</span>
					<span className="span-body-2 span-white">{missingHours(recentUtilisation.previousPeriod)} hrs</span>
				</Col>
			</Row>
		</DashboardCard>
	)
}

export default MissingTimesheets
